import gql from 'fraql'
export default {
  GIVE_DELIVERY_TO_COURIER: gql`mutation giveDeliveryToCourier ($idDelivery: Int!, $idCourier: Int) {
    giveDeliveryToCourier(input:{idDelivery: $idDelivery, idCourier: $idCourier}) {
      boolean
    }
  }`,
  ASSIGN_ORDERS_TO_COURIER: gql`
    mutation assignOrdersToCourier ($idDelivery: Int!, $orderIds: [Int!], $idCourier: Int!) {
      assignOrdersToCourier(input: {idDelivery: $idDelivery, orderIds: $orderIds, idCourier: $idCourier}) {
        boolean
      }
    }
  `,
  PRINT_PREORDERS: gql`mutation printPreorders($date: Date!)  {
    printReportPreorders(input: {date: $date}) {
      clientMutationId
    }
  }`,
  CREATE_DELIVERY_FROM_ORDERS: gql`mutation createDeliveryFromOrders($orderIds: [Int!]) {
      createDeliveryFromOrders(input: {orderIds: $orderIds}) {
        integer
      }
  }`,
  DELIVERIES_APPOINT_COURIER: gql`mutation deliveriesAppointCourier($deliveriesIds: [Int!], $idCourier: Int) {
    deliveriesAppointCourier(input: {deliveriesIds: $deliveriesIds, idCourier: $idCourier})  {
      clientMutationId
    }
  }`,
  DISBAND_DELIVERY: gql`mutation disbandDelivery($deliveryId: Int!) {
    disbandDelivery(input: {deliveryId: $deliveryId})  {
      clientMutationId
    }
  }`,
  ADD_ORDER_TO_DELIVERY: gql`mutation addOrderToDelivery($deliveryId: Int!, $orderIds: [Int!]) {
    addOrderToDelivery(input: {deliveryId: $deliveryId, ordersIds: $orderIds})  {
      clientMutationId
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/logistian.js